


























export default {
    props: {
        categories: Array,
        displayAge: String
    }, 
    created() {
     
    },
    computed: {
        computedTotalValue : function() {
            let buildArray = [];
            this.categories.map((ele) =>  {
                for(let i = 0; i < ele.value; i++) {
                    
                    if(ele['ageList'] != null) {
                        //Get age from agelist
                        buildArray.push(ele.ageList[i]);
                    }else {
                        buildArray.push(ele.from);
                    }
                }
            });
            return buildArray.join(',');
        }
    },
    methods: {
        ageCountChanged(ageCatIndex, event) {
            if(this.categories[ageCatIndex]["ageList"] != null) {
                if(this.categories[ageCatIndex].ageList.length > parseInt(event.detail[0])) {
                    this.categories[ageCatIndex].ageList = (<number[]>this.categories[ageCatIndex].ageList).slice(0,parseInt(event.detail[0]));
                }else {
                    //Current number of items in index
                    //loop for every missing element in array
                    for(let i = this.categories[ageCatIndex].ageList.length; i < parseInt(event.detail[0]); i++) {
                        this.categories[ageCatIndex].ageList.push(this.categories[ageCatIndex].from); 
                    }
                }
            }
        
        },
        emitChange() {
            this.$emit("change");
        }
    }
}
